import { aspenApi as api, getAssetCurrencyConfig } from "@aspen/services";
import { generateDataCacheKey } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import { updateDepositCoinList, useAppDispatch } from "@aspen/store";
import type { IWalletAssetsConfig } from "@aspen/model";

/**
 * 获取币种的多链列表。
 */
export const useFetchDepositCoinList = (params?: IWalletAssetsConfig) => {
  const apiPath = api.wallet.assetCurrencyConfig;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const dispatch = useAppDispatch();
  const { error, data, isLoading, refetch } = useQuery({
    queryKey: [queryKey, Object.values(params || {})],
    queryFn: () => {
      return getAssetCurrencyConfig(params).then(res => {
        if (res?.code == "0") {
          dispatch(updateDepositCoinList(res?.data));
          return res.data;
        }
      });
    },
  });
  return { error, data, refetch, queryKey, isLoading };
};
